export default Object.freeze({
  events: {
    settingsClearErrors: 'settings:clear-errors'
  },
  alerts: {
    types: {
      danger: 'danger',
      primary: 'primary',
      success: 'success',
      warning: 'warning'
    },
    events: { // consumed as v-on:event-name
      channelInfo: 'channel-alert',
      updateModeView: 'update-mode-view'
    }
  },
  platforms: {
    rbm: {
      agentStates: {
        new: 'new',
        createRequested: 'create_requested',
        created: 'created',
        launchRequested: 'launch_requested',
        launched: 'launched'
      },
      regions: {
        asiaPacific: 'asia_pacific',
        europe: 'europe',
        northAmerica: 'north_america'
      }
    }
  }
})
